import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const HERO_IMAGES = [
  'https://public.readdy.ai/ai/img_res/562832d7b3347031ff68a038e27d88aa.jpg',
  'https://readdy.ai/api/search-image?query=Japanese%20neon%20city%20pharmacy%20night%20cyberpunk%20rain%20reflections%20neon%20signs%20glowing%20street%20dark%20futuristic%20atmospheric%20moody%20colorful%20wide%20shot&width=1440&height=860&seq=hero2&orientation=landscape',
  'https://readdy.ai/api/search-image?query=futuristic%20pharmacy%20holographic%20display%20cyberpunk%20neon%20glow%20dark%20background%20medical%20technology%20advanced%20glowing%20panels%20wide%20cinematic&width=1440&height=860&seq=hero3&orientation=landscape',
];

const SLIDES = [
  {
    title: 'АПТЕКА',
    subtitle: 'БУДУЩЕГО',
    desc: 'Передовые формулы современной фармакологии. Доставка за 2 часа по всему городу.',
    cta: 'НАЧАТЬ ПОКУПКИ',
    ctaHref: '/catalog',
    ctaSecond: 'КАТАЛОГ',
    ctaSecondHref: '/catalog',
    accent: '#ff2d78',
  },
  {
    title: 'ЯПОНСКИЕ',
    subtitle: 'ФОРМУЛЫ',
    desc: 'Оригинальные препараты высшего качества. Прямые поставки без посредников.',
    cta: 'СМОТРЕТЬ НОВИНКИ',
    ctaHref: '/catalog',
    ctaSecond: 'АКЦИИ',
    ctaSecondHref: '/promos',
    accent: '#00f5ff',
  },
  {
    title: 'РАБОТАЕМ',
    subtitle: '24/7',
    desc: 'Ночная аптека всегда на связи. Быстрая доставка в любое время суток.',
    cta: 'ЗАКАЗАТЬ СЕЙЧАС',
    ctaHref: '/catalog',
    ctaSecond: 'КОНТАКТЫ',
    ctaSecondHref: '/contacts',
    accent: '#39ff14',
  },
];

const HeroBanner = () => {
  const [current, setCurrent] = useState(0);
  const [animating, setAnimating] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setAnimating(true);
      setTimeout(() => {
        setCurrent((prev) => (prev + 1) % SLIDES.length);
        setAnimating(false);
      }, 400);
    }, 6000);
    return () => clearInterval(timer);
  }, []);

  const slide = SLIDES[current];

  return (
    <section id="hero" className="relative min-h-screen w-full overflow-hidden flex items-center">
      {/* Background Images */}
      {HERO_IMAGES.map((img, idx) => (
        <div
          key={idx}
          className="absolute inset-0 transition-opacity duration-1000"
          style={{ opacity: idx === current ? 1 : 0 }}
        >
          <img src={img} alt="hero" className="w-full h-full object-cover object-top" />
        </div>
      ))}

      {/* Overlays */}
      <div className="absolute inset-0 bg-gradient-to-r from-dark-base/90 via-dark-base/60 to-dark-base/30" />
      <div className="absolute inset-0 bg-gradient-to-t from-dark-base via-transparent to-dark-base/50" />
      <div className="scanline absolute inset-0 opacity-30" />

      {/* Grid BG */}
      <div className="absolute inset-0 grid-bg opacity-30" />

      {/* Content */}
      <div className="relative z-10 w-full px-6 lg:px-20 pt-24">
        <div
          className="transition-all duration-400"
          style={{ opacity: animating ? 0 : 1, transform: animating ? 'translateY(20px)' : 'translateY(0)' }}
        >
          {/* Main Title */}
          <h1 className="font-orbitron font-black leading-none mb-2">
            <span
              className="block text-white"
              style={{ fontSize: 'clamp(48px, 8vw, 96px)', textShadow: '0 0 30px rgba(255,255,255,0.3)' }}
            >
              {slide.title}
            </span>
            <span
              className="block"
              style={{
                fontSize: 'clamp(48px, 8vw, 96px)',
                color: slide.accent,
                textShadow: `0 0 20px ${slide.accent}, 0 0 60px ${slide.accent}`,
              }}
            >
              {slide.subtitle}
            </span>
          </h1>

          {/* Description */}
          <p className="mt-6 font-mono text-sm md:text-base text-white/60 max-w-lg leading-relaxed">
            {slide.desc}
          </p>

          {/* CTA Buttons */}
          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <Link
              to={slide.ctaHref}
              className="whitespace-nowrap btn-neon-pink px-8 py-4 rounded-full font-orbitron font-bold text-sm tracking-widest cursor-pointer inline-flex items-center"
              style={{ fontSize: '13px' }}
            >
              {slide.cta}
              <i className="ri-arrow-right-line ml-3" />
            </Link>
            <Link
              to={slide.ctaSecondHref}
              className="whitespace-nowrap btn-neon-cyan px-8 py-4 rounded-full font-orbitron font-bold text-sm tracking-widest cursor-pointer inline-flex items-center justify-center"
              style={{ fontSize: '13px' }}
            >
              {slide.ctaSecond}
            </Link>
          </div>

          {/* Stats */}
          <div className="mt-16 flex gap-8 flex-wrap">
            {[
              { val: '10 000+', label: 'Товаров' },
              { val: '2 часа', label: 'Доставка' },
              { val: '24/7', label: 'Работаем' },
              { val: '98%', label: 'Довольных' },
            ].map((stat) => (
              <div key={stat.val} className="flex flex-col">
                <span
                  className="font-orbitron font-black text-2xl text-neon-cyan"
                  style={{ textShadow: '0 0 15px #00f5ff' }}
                >
                  {stat.val}
                </span>
                <span className="font-mono text-xs text-white/50 mt-1">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Slide indicators */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex gap-3 z-10">
        {SLIDES.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setCurrent(idx)}
            className="cursor-pointer transition-all duration-300"
          >
            <div
              className="h-1 rounded-full transition-all duration-300"
              style={{
                width: idx === current ? '40px' : '12px',
                background: idx === current ? '#ff2d78' : 'rgba(255,255,255,0.3)',
                boxShadow: idx === current ? '0 0 10px #ff2d78' : 'none',
              }}
            />
          </button>
        ))}
      </div>

      {/* Side decorative element */}
      <div className="absolute right-8 top-1/2 -translate-y-1/2 hidden xl:flex flex-col items-center gap-3">
        <div className="w-px h-32 bg-gradient-to-b from-transparent to-neon-pink" style={{ boxShadow: '0 0 8px #ff2d78' }} />
        <div className="font-mono text-xs text-neon-pink/50 [writing-mode:vertical-rl] tracking-[0.3em] animate-flicker">
          АПТЕКА 24/7 НЕОН
        </div>
        <div className="w-px h-32 bg-gradient-to-t from-transparent to-neon-cyan" style={{ boxShadow: '0 0 8px #00f5ff' }} />
      </div>
    </section>
  );
};

export default HeroBanner;
